var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teste pa-0"},[_c('v-slider',{staticClass:"pa-0",attrs:{"height":"20px","width":"20px","readonly":"","step":_vm.value,"success":_vm.value == '100' ? true : false,"thumb-label":"always","color":"info darken-3"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }